import React, { Component } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { push } from 'connected-react-router';
import { change, SubmissionError } from 'redux-form';
import PropTypes from 'prop-types';
import { graphql } from 'react-apollo';
import { store, history } from 'store';
import isEqual from 'lodash.isequal';
import { RESET_SELECTED_FIELD, UPDATE_MAP_FIELDS } from 'common/constants';
import { banner } from 'actions';
import { FieldWrapper, LevelNav, ErrorModal } from 'common/components';
import { LandingForm, ActivityForm } from './forms';
import {
  ACTIVITY_TYPES,
  ANALYTICS,
  BANNER_IDS,
  ERROR_DEFAULT,
  ROUTE_ACTIVITY,
  SCOUTING,
  FIELD_DISPLAY_TOGGLE,
} from 'common/constants';
import {
  FETCH_ACTIVITY,
  FETCH_STORAGE_ACTIVITY,
  FETCH_DELIVERY_ACTIVITY,
  FETCH_ALL_EXCEPT_ACTIVITIES,
  FETCH_ALL_ACTIVITIES_WITH_FIELDS,
  MUTATION_CREATE_FIELD_ACTIVITY,
  MUTATION_CREATE_STORAGE_ACTIVITY,
  MUTATION_CREATE_DELIVERY_ACTIVITY,
  MUTATION_UPDATE_FIELD_ACTIVITY,
  MUTATION_UPDATE_STORAGE_ACTIVITY,
  MUTATION_UPDATE_DELIVERY_ACTIVITY,
} from 'api/activity';
import { FETCH_FIELD_DETAILS_WITH_NAME } from 'api/field';
import {
  MUTATION_CREATE_CROP,
  MUTATION_DELETE_CROP,
  MUTATION_UPDATE_CROP,
} from 'api/crop';
import { generateFieldId } from 'util/ids';
import {
  graphQlToFormErrors,
  capitalizeString,
  getHarvestedFlag,
  sumArray,
  omitDeep,
  convertJsonToObj,
} from 'common/utils';
import { toCommaNumber } from 'common/formatters';
import { maxValue } from 'common/form-validators';
import mixpanel from 'mixpanel-browser';
import uuidv4 from 'uuid/v4';
import {
  buildActivitySchema,
  buildCropchema,
  mapInitialValuesForStorageActivity,
  mapInitialValuesForDeliveryActivity,
  mapInitialValues,
  formatFieldActivityUpdateInput,
} from './utils';
import './index.css';

let error = {};
class WizardForm extends Component {
  state = {
    page: 1,
    component: null,
    selectedField: [],
    openErrorModal: false,
  };

  prevPage = () => {
    this.setState({ page: 1, component: null });
  };

  goToOption = (component = null) => {
    this.setState({ page: 2, component });
  };

  updateselectedField = selectedField => {
    this.setState({ selectedField });
  };

  getQtyError = max => `Only ${toCommaNumber(max)} bushels available`;

  getDestValues = (values, namespace) => {
    const arr = values[`${namespace}s`];
    return arr
      ? arr.map((item, idx) => {
          const { id, name, type, max } = JSON.parse(item);
          // append error
          const fieldname = `${namespace}s_amount`;
          if (Number(values[fieldname][idx]) > max) {
            if (!error[fieldname]) {
              error[fieldname] = [];
            }
            error[fieldname][idx] = this.getQtyError(max);
          }
          return {
            amount: { size: values[fieldname][idx], type: 'bushels' },
            destination: { id, name, type },
          };
        })
      : [];
  };
  // Fertilizer spacific data handling
  getFertilizerOrChemicalValues = (values, namespace) => {
    const arr = values[`${namespace}s`];

    return (arr || []).map((item, idx) => {
      const { name, ...rest } = JSON.parse(item);
      // remove id and __typename to prevent gql input mismatch
      delete rest.id;
      delete rest.__typename;
      const fieldname = `${namespace}s_amount`;

      return {
        name,
        value: { ...rest, notes: values[fieldname][idx] },
      };
    });
  };

  getSeedingValues = (
    { plantedArea, seedingRate, expectedYield, chemical, inoculant },
    fertilizers
  ) => ({
    plantedArea: {
      size: plantedArea,
      type: 'acres', // BE has default values too
    },
    seedingRate: seedingRate || null,
    fertilizers,
    expectedYield: {
      size: expectedYield,
      harvested: false,
      type: 'bushels',
      per: 'acres',
    },
    chemical,
    inoculant,
  });

  populateAmount = (destType, values, dispatch, prevValues) => {
    const { amount, storages_amount, others, contracts_amount } = values;
    const dest = values[destType];
    if (dest) {
      if (
        dest.length >
        ((prevValues[destType] && prevValues[destType].length) || 0)
      ) {
        const index = dest.length - 1;
        const storagesTotal = sumArray(storages_amount || []);
        const othersTotal = sumArray(
          (others || []).map(other => Number(other.amount))
        );
        const contractsTotal = sumArray(contracts_amount || []);
        const usedAmount = storagesTotal + othersTotal + contractsTotal;
        const remainingAmount = amount - usedAmount;
        const max = JSON.parse(dest[index]).max;
        dispatch(
          change(
            'activityform',
            `${destType}_amount[${index}]`,
            remainingAmount <= max ? remainingAmount : max
          )
        );
      }
      this.prevPage();
    }
  };

  _toggleErrorModal = shouldOpen => {
    this.setState(({ openErrorModal }) => ({
      openErrorModal: typeof open === 'boolean' ? shouldOpen : !openErrorModal,
    }));
  };

  _setFieldLocaiton = location => {
    store.dispatch(
      change('activityform', 'location', `${location.lat}, ${location.lng}`)
    );
  };

  _updateCrop = (vars, cropVars) => {
    const { season, onUpdateCrop } = this.props;
    const { expectedYield, plantedArea } = cropVars;
    const cropId = `CROPFIELD:${season}:${vars.fieldName}:${
      vars.crop.name
    }:${vars.crop.variety || ''}`;
    return onUpdateCrop(cropId, { expectedYield, plantedArea });
  };

  // put this here for now
  onSubmit = async values => {
    // empty the error initially
    error = {};
    const {
      onCancel,
      id,
      activityType,
      crops,
      originalCrop,
      extra,
      onCreateFieldActivity,
      onUpdateFieldActivity,
      onCreateStorageActivity,
      onUpdateStorageActivity,
      onUpdateDeliveryActivity,
      onCreateDeliveryActivity,
      onCreateCrop,
      // onDeleteCrop,
      triggerBanner,
      initialValues,
      season,
    } = this.props;
    const crop = values.crop && JSON.parse(values.crop);
    let vars = {
      season,
      crop:
        crop && crop.name
          ? { name: crop.name, variety: crop.variety || values.variety || null }
          : null,
      activityDate:
        typeof values.activityDate === 'object'
          ? values.activityDate.toISOString()
          : values.activityDate,
      notes: values.notes || null,
    };
    let cropVars = {};
    // field
    if (values.fieldName) {
      const fieldName = JSON.parse(values.fieldName).name;
      vars = {
        fieldName,
        ...vars,
      };
    }

    // activity status
    if (values.status) {
      vars.finishDate = values.finishDate || new Date().toISOString();
    } else {
      vars.finishDate = null;
    }

    // destination
    const storages = this.getDestValues(values, 'storage');
    const contracts = this.getDestValues(values, 'contract');
    const fertilizers = this.getFertilizerOrChemicalValues(
      values,
      'fertilizer'
    );
    const chemicals = this.getFertilizerOrChemicalValues(values, 'chemical');
    const seeding = this.getSeedingValues(values, fertilizers);

    const others = values.others
      ? values.others
          .filter(other => other.name)
          .map(other => ({
            amount: { size: other.amount, type: 'bushels' },
            destination: {
              name: other.name,
              type: 'OTHER',
              id: `OTHER:${other.name}`,
            },
          }))
      : [];
    const destinations = [
      ...storages,
      ...contracts,
      ...fertilizers,
      ...chemicals,
      ...others,
    ];

    // to allow two decimals
    let amount = values.amount ? parseInt(values.amount, 10) * 100 : 0;
    let total =
      destinations.length > 0
        ? destinations
            .map(destination =>
              destination.amount
                ? parseInt(destination.amount.size, 10) * 100
                : 0
            )
            .reduce((sum, current) => sum + current)
        : 0;

    // source (for storage / other only)
    const sourceName = values.storage ? 'storage' : 'other';
    const sourceObj =
      sourceName === 'other'
        ? {
            id: `OTHER:${values[sourceName]}`,
            name: values[sourceName],
            type: 'OTHER',
            max: null,
          }
        : JSON.parse(values[sourceName]);
    const source = {
      id: sourceObj.id,
      name: sourceObj.name,
      type: sourceObj.type,
    };
    const isCreating = id === 'add';
    // use maxValue validation (undefined when valid) in case sourceObj.max is string
    if (sourceObj.max && maxValue(amount / 100, sourceObj.max)) {
      error['amount'] = this.getQtyError(sourceObj.max);
    }

    //validation for seeding activity (create crop in a field):
    // throw error when adding an existing crop name + variety to the same field
    if (activityType === ACTIVITY_TYPES.SEEDING) {
      const { name } = crop;
      const { variety } = values;

      // only validate when name and variety are different from the original one (when updating)
      if (
        isCreating ||
        !(name === originalCrop.name && variety === originalCrop.variety)
      ) {
        if (
          crops.some(
            crp =>
              crp.fieldName === vars.fieldName &&
              crp.crop &&
              crp.crop.name === name &&
              crp.crop.variety === variety
          )
        ) {
          throw new SubmissionError({
            variety:
              'This variety already exists on this field, please use a new variety or update the existing crop.',
          });
        }
      }
    }

    if (
      !isCreating &&
      [
        ACTIVITY_TYPES.STORAGE,
        ACTIVITY_TYPES.DELIVERY,
        ACTIVITY_TYPES.HARVESTING,
      ].includes(activityType)
    ) {
      this.validateCropTypes(initialValues, values);
      this.validateStorageQuantities(initialValues, values);
    }

    let location = {}; // for SCOUTING map location
    switch (activityType) {
      case ACTIVITY_TYPES.DELIVERY:
        vars = {
          ...vars,
          source,
          destination: destinations.length ? destinations[0] : null,
        };
        break;

      case ACTIVITY_TYPES.STORAGE:
        vars = {
          ...vars,
          source,
          destinations: destinations.length ? destinations : null,
        };
        break;

      case ACTIVITY_TYPES.HARVESTING:
        vars = {
          ...vars,
          fieldActivityType: activityType,
          harvesting: destinations.length ? destinations : null,
          yield: {
            harvested: !!values.yield,
            size: values.yield,
            type: 'bushels',
            per: 'acres',
          },
        };
        break;

      case ACTIVITY_TYPES.OTHER:
        vars = {
          ...vars,
          fieldActivityType: values.type,
        };
        break;

      case ACTIVITY_TYPES.SCOUTING:
        if (values.location) {
          const [lat, lng] = values.location.replace(/\s/g, '').split(',');
          location = { lat, lng };
        }
        vars = {
          ...vars,
          fieldActivityType: activityType,
          observations: [
            {
              name: SCOUTING.WEEDS,
              value: {
                severity: values.weeds || 'NONE',
                notes: values.weedsNotes || '',
              },
            },
            {
              name: SCOUTING.INSECTS,
              value: {
                severity: values.insects || 'NONE',
                notes: values.insectsNotes || '',
              },
            },
          ],
          location,
        };
        break;

      case ACTIVITY_TYPES.FERTILIZING:
        vars = {
          ...vars,
          fieldActivityType: activityType,
          fertilizing: destinations,
        };
        break;

      case ACTIVITY_TYPES.SPRAYING:
        vars = {
          ...vars,
          fieldActivityType: activityType,
          chemicals: destinations,
          sprayingRate: values.sprayingRate,
        };
        break;
      case ACTIVITY_TYPES.SEEDING:
        vars = {
          ...vars,
          fieldActivityType: activityType,
          seeding,
        };
        cropVars = {
          crop: vars.crop,
          fieldName: vars.fieldName,
          season,
          expectedYield: seeding.expectedYield,
          plantedArea: seeding.plantedArea,
        };
        break;
      default:
        break;
    }

    const ERROR_AMOUNT =
      'The quantity in the destinations does not match with the source, please try again';

    // FE quantity validation happens
    if (
      (error.constructor === Object && Object.keys(error).length > 0) ||
      amount !== total
    ) {
      let errors = error;
      if (amount !== total) {
        errors = { ...errors, _error: ERROR_AMOUNT };
      }
      throw new SubmissionError({ ...errors });
      // BE validation happens
    } else {
      let res = {};
      // let crop = {};

      if (id === 'add') {
        const api = {
          STORAGE: onCreateStorageActivity,
          DELIVERY: onCreateDeliveryActivity,
          HARVESTING: onCreateFieldActivity,
          OTHER: onCreateFieldActivity,
          SCOUTING: onCreateFieldActivity,
          FERTILIZING: onCreateFieldActivity,
          SPRAYING: onCreateFieldActivity,
          SEEDING: async vars => {
            extra === 'crop'
              ? await this._updateCrop(vars, cropVars)
              : await onCreateCrop(cropVars);

            return onCreateFieldActivity(vars);
          },
        };

        res = await api[activityType](vars);
      } else {
        if (activityType === ACTIVITY_TYPES.SEEDING) {
          await this._updateCrop(vars, cropVars);
        }

        if (activityType === ACTIVITY_TYPES.STORAGE) {
          res = await onUpdateStorageActivity(
            id,
            formatFieldActivityUpdateInput(vars)
          ).catch(() => {
            this._toggleErrorModal(true);
          });
        } else if (activityType === ACTIVITY_TYPES.DELIVERY) {
          res = await onUpdateDeliveryActivity(
            id,
            formatFieldActivityUpdateInput(vars)
          ).catch(() => {
            this._toggleErrorModal(true);
          });
        } else {
          res = await onUpdateFieldActivity(
            id,
            formatFieldActivityUpdateInput(vars)
          );
        }
      }

      if (res && (res.createActivity || res.updateActivity)) {
        triggerBanner(
          BANNER_IDS.APP,
          `ACTIVITY ${id === 'add' ? 'ADDED' : 'UPDATED'}`,
          false
        );

        let source = 'Other';
        if (
          activityType === ACTIVITY_TYPES.STORAGE ||
          activityType === ACTIVITY_TYPES.DELIVERY
        )
          source = values.storage ? 'Storage' : 'Other';
        if (
          (activityType === 'OTHER' ||
            activityType === ACTIVITY_TYPES.HARVESTING) &&
          values.fieldName
        )
          source = 'Field';

        const storageDestinationLength =
          values.storages && values.storages.length;
        const otherDestinationLength = values.others && values.others.length;
        const contractDestinationLength =
          values.contracts && values.contracts.length;

        const { createActivity = {}, updateActivity = {} } = res;
        const type =
          createActivity.fieldActivityType ||
          createActivity.activityType ||
          updateActivity.fieldActivityType ||
          updateActivity.activityType;

        mixpanel.track(ANALYTICS.EVENTS.ACTIVITY.LOGGED, {
          [ANALYTICS.PROPERTIES.ACTIVITY.TYPE]: capitalizeString(
            type.toLowerCase()
          ),
          [ANALYTICS.PROPERTIES.ACTIVITY.SOURCE]: source,
          [ANALYTICS.PROPERTIES.ACTIVITY.DESTINATION_STORAGE]:
            storageDestinationLength || '',
          [ANALYTICS.PROPERTIES.ACTIVITY.DESTINATION_CONTRACT]:
            contractDestinationLength || '',
          [ANALYTICS.PROPERTIES.ACTIVITY.DESTINATION_OTHER]:
            otherDestinationLength || '',
          [ANALYTICS.PROPERTIES.ACTIVITY
            .DATE_OF_ACTIVITY]: values.activityDate.toString(),
        });

        mixpanel.people.increment('Activities Logged');
        onCancel();
      } else if (res && res.errors) {
        const _error = res.errors[0] ? res.errors[0].message : ERROR_DEFAULT;
        // if (activityType === ACTIVITY_TYPES.SEEDING) {
        //   await onDeleteCrop(crop.id);
        // }
        throw new SubmissionError({ _error });
      } else {
        throw new SubmissionError({ _error: ERROR_DEFAULT });
      }
    }
  };

  validateCropTypes = (initValues, values) => {
    const { storages, contracts } = this.props;
    const {
      storage: oldSource,
      storages: oldStorageDestinations,
      contracts: oldContractDestinations,
      crop,
    } = initValues;
    const {
      storages: newStorageDestinations,
      contracts: newContractDestinations,
    } = values;

    const errors = {};

    const storageCrops = storages
      .filter(s => s.active)
      .reduce((result, { id, crop }) => {
        result[id] = crop;
        return result;
      }, {});

    const contractCrops = contracts
      .filter(c => c.active)
      .reduce((result, { id, crop }) => {
        result[id] = crop;
        return result;
      }, {});

    let crops = { ...storageCrops, ...contractCrops };
    const cropObj = convertJsonToObj(crop);

    // only need to validate the original source storage's crop,
    // because users cannot select non-existed storage
    // validate source (storage)
    if (oldSource) {
      const obj = convertJsonToObj(oldSource);
      const storageCrop = crops[obj.id];
      if (storageCrop && cropObj.name !== storageCrop.name) {
        errors.amount = `Crop in the storage ${obj.name} has changed`;
      }
    }

    //validate new destinations (storage)
    let storagesAmountErrors = [];
    const newDestStorageIds = [];
    if (newStorageDestinations && newStorageDestinations.length > 0) {
      newStorageDestinations.forEach((storage, idx) => {
        const obj = convertJsonToObj(storage);
        newDestStorageIds.push(obj.id);
        const storageCrop = crops[obj.id];
        if (storageCrop && cropObj.name !== storageCrop.name) {
          storagesAmountErrors[idx] = `Crop in the storage ${
            obj.name
          } has changed`;
        }
      });
      if (storagesAmountErrors.filter(e => !!e).length > 0) {
        errors.storages_amount = storagesAmountErrors;
      }
    }

    //validate removed destinations (storage)
    let removedDestStorageError;
    if (oldStorageDestinations && oldStorageDestinations.length > 0) {
      oldStorageDestinations.forEach(storage => {
        const obj = convertJsonToObj(storage);
        const storageCrop = crops[obj.id];
        if (
          storageCrop &&
          cropObj.name !== storageCrop.name &&
          !newDestStorageIds.includes(obj.id)
        ) {
          removedDestStorageError = `Crop in the storage ${
            obj.name
          } has changed`;
        }
      });
      if (removedDestStorageError) {
        errors._error = removedDestStorageError;
      }
    }

    //validate new destinations (contract)
    let contractsAmountErrors = [];
    const newDestContractIds = [];
    if (newContractDestinations && newContractDestinations.length > 0) {
      newContractDestinations.forEach((contract, idx) => {
        const obj = convertJsonToObj(contract);
        newDestContractIds.push(obj.id);
        const contractCrop = crops[obj.id];
        if (contractCrop && cropObj.name !== contractCrop.name) {
          contractsAmountErrors[idx] = `Crop on the contract ${
            obj.name
          } has changed`;
        }
      });
      if (contractsAmountErrors.filter(e => !!e).length > 0) {
        errors.contracts_amount = contractsAmountErrors;
      }
    }

    //validate removed destinations (contract)
    let removedDestContractError;
    if (oldContractDestinations && oldContractDestinations.length > 0) {
      oldContractDestinations.forEach(contract => {
        const obj = convertJsonToObj(contract);
        const contractCrop = crops[obj.id];
        if (
          contractCrop &&
          cropObj.name !== contractCrop.name &&
          !newDestContractIds.includes(obj.id)
        ) {
          removedDestContractError = `Crop on the contract ${
            obj.name
          } has changed`;
        }
      });
      if (removedDestContractError) {
        errors._error = removedDestContractError;
      }
    }

    if (Object.keys(errors).length > 0) {
      throw new SubmissionError(errors);
    }
  };

  calculateQuantities = (obj, amount, currentQuantities) => {
    if (obj && obj.id) {
      const currentQuantity = currentQuantities[obj.id];
      if (currentQuantity) {
        currentQuantity.used += amount;
      }
    }
  };

  validateQuantity = (obj, finalQuantities) => {
    // ignore OTHER type
    if (obj && obj.type !== 'OTHER') {
      const storageQuantity = finalQuantities[obj.id];
      if (!storageQuantity) {
        switch (obj.type) {
          case 'STORAGE':
            return `${obj.type.charAt(0)}${obj.type.slice(1).toLowerCase()} ${
              obj.name
            } has been deleted`;
          case 'CONTRACT':
            return `Selected contract ${obj.name} does not exist anymore`;
        }
      }

      const { size, used } = storageQuantity;
      if (used > size) {
        return `Not enough space available in the ${obj.type.toLowerCase()} ${
          obj.name
        }`;
      } else if (used < 0) {
        return `Not enough bushels available in the ${obj.type.toLowerCase()} ${
          obj.name
        }`;
      }
    }
  };

  validateStorageQuantities = (initValues, values) => {
    if (!initValues || !values) return;

    const errors = {};
    const { storages, contracts } = this.props;

    const {
      storage: oldSource,
      amount: oldAmount,
      storages: oldStorageDestinations,
      storages_amount: oldStorageDestinationsAmount,
      contracts: oldContractDestinations,
      contracts_amount: oldContractDestinationsAmount,
    } = initValues;

    const {
      storage: newSource,
      amount: newAmount,
      storages: newStorageDestinations,
      storages_amount: newStorageDestinationsAmount,
      contracts: newContractDestinations,
      contracts_amount: newContractDestinationsAmount,
    } = values;

    const currentStorageQuantities = storages
      .filter(s => s.active)
      .reduce((result, { id, capacity: { size, used } }) => {
        result[id] = { size, used };
        return result;
      }, {});

    const currentContractQuantities = contracts
      .filter(c => c.active)
      .reduce((result, { id, quantity: { contracted, delivered } }) => {
        result[id] = { size: contracted.size, used: delivered.size };
        return result;
      }, {});

    let currentQuantities = {
      ...currentStorageQuantities,
      ...currentContractQuantities,
    };

    // calculate source's quantity (storage)
    if (oldSource) {
      const obj = convertJsonToObj(oldSource);
      const amount = parseInt(oldAmount, 10);
      this.calculateQuantities(obj, amount, currentQuantities);
    }
    if (newSource) {
      const obj = convertJsonToObj(newSource);
      const amount = -parseInt(newAmount, 10);
      this.calculateQuantities(obj, amount, currentQuantities);
    }

    // calculate destinations' quantity (storages)
    if (oldStorageDestinations && oldStorageDestinations.length > 0) {
      oldStorageDestinations.forEach((storage, idx) => {
        const obj = convertJsonToObj(storage);
        const amount = -parseInt(oldStorageDestinationsAmount[idx], 10);
        this.calculateQuantities(obj, amount, currentQuantities);
      });
    }
    if (newStorageDestinations && newStorageDestinations.length > 0) {
      newStorageDestinations.forEach((storage, idx) => {
        const obj = convertJsonToObj(storage);
        const amount = parseInt(newStorageDestinationsAmount[idx], 10);
        this.calculateQuantities(obj, amount, currentQuantities);
      });
    }

    // calculate destinations' quantity (contracts)
    if (oldContractDestinations && oldContractDestinations.length > 0) {
      oldContractDestinations.forEach((contract, idx) => {
        const obj = convertJsonToObj(contract);
        const amount = -parseInt(oldContractDestinationsAmount[idx], 10);
        this.calculateQuantities(obj, amount, currentQuantities);
      });
    }
    if (newContractDestinations && newContractDestinations.length > 0) {
      newContractDestinations.forEach((contract, idx) => {
        const obj = convertJsonToObj(contract);
        const amount = parseInt(newContractDestinationsAmount[idx], 10);
        this.calculateQuantities(obj, amount, currentQuantities);
      });
    }

    let amountError;
    // validate source (storage)
    if (oldSource) {
      const obj = convertJsonToObj(oldSource);
      if (obj) {
        const err = this.validateQuantity(obj, currentQuantities);
        if (err) amountError = err;
      }
    }
    if (newSource) {
      const obj = convertJsonToObj(newSource);
      if (obj) {
        const err = this.validateQuantity(obj, currentQuantities);
        if (err) amountError = err;
      }
    }
    if (amountError) {
      errors.amount = amountError;
    }

    // validate new destinations (storage)
    let storagesAmountErrors = [];
    const newDestStorageIds = [];
    if (newStorageDestinations && newStorageDestinations.length > 0) {
      newStorageDestinations.forEach((storage, idx) => {
        const storageObj = convertJsonToObj(storage);
        if (storageObj) {
          newDestStorageIds.push(storageObj.id);
          storagesAmountErrors[idx] = this.validateQuantity(
            storageObj,
            currentQuantities
          );
        }
      });
      if (storagesAmountErrors.filter(e => !!e).length > 0) {
        errors.storages_amount = storagesAmountErrors;
      }
    }

    // validate removed destinations (storage)
    let removedDestStorageError;
    if (oldStorageDestinations && oldStorageDestinations.length > 0) {
      oldStorageDestinations.forEach(storage => {
        const storageObj = convertJsonToObj(storage);
        if (storageObj && !newDestStorageIds.includes(storageObj.id)) {
          removedDestStorageError = this.validateQuantity(
            storageObj,
            currentQuantities
          );
        }
      });
      if (removedDestStorageError) {
        errors._error = removedDestStorageError;
      }
    }

    // validate new destinations (contract)
    let contractsAmountErrors = [];
    const newDestContractIds = [];
    if (newContractDestinations && newContractDestinations.length > 0) {
      newContractDestinations.forEach((contract, idx) => {
        const contractObj = convertJsonToObj(contract);
        if (contractObj) {
          newDestContractIds.push(contractObj.id);
          contractsAmountErrors[idx] = this.validateQuantity(
            contractObj,
            currentQuantities
          );
        }
      });
      if (contractsAmountErrors.filter(e => !!e).length > 0) {
        errors.contracts_amount = contractsAmountErrors;
      }
    }

    // validate removed destinations (contract)
    let removedDestContractError;
    if (oldContractDestinations && oldContractDestinations.length > 0) {
      oldContractDestinations.forEach(contract => {
        const contractObj = convertJsonToObj(contract);
        if (contractObj && !newDestContractIds.includes(contractObj.id)) {
          removedDestContractError = this.validateQuantity(
            contractObj,
            currentQuantities
          );
        }
      });
      if (removedDestContractError) {
        errors._error = removedDestContractError;
      }
    }

    // throw submission errors
    if (Object.keys(errors).length > 0) {
      throw new SubmissionError(errors);
    }
  };

  getSelectedCrop = activityform => {
    // filter fields from crop selection
    const values = activityform && activityform.values;
    return values && values.crop && JSON.parse(values.crop);
  };

  getSelectedFields = activityform => {
    const { fields, crops, season } = this.props;
    const selectedCrop = this.getSelectedCrop(activityform);
    let selectedFields = fields;

    selectedFields =
      fields &&
      fields.map(field => {
        const activeCrops =
          crops &&
          crops.filter(
            crop =>
              field.id === generateFieldId(crop.fieldName) &&
              crop.season === season
          );
        const harvested = getHarvestedFlag(activeCrops);

        let disabled = false;

        // only when a crop is selected, show only fields with the crop
        if (selectedCrop) {
          // if `Empty Field` is selected
          if (selectedCrop.name === null) {
            disabled = activeCrops && activeCrops.length > 0;

            // if specific crop is selected
          } else {
            disabled = activeCrops
              ? !activeCrops.find(
                  crop =>
                    crop.crop.name === selectedCrop.name &&
                    crop.crop.variety === selectedCrop.variety
                )
              : true;
          }
        }

        // add actual matched crops to highlight only the field with crops
        return activeCrops
          ? { ...field, crops: activeCrops, disabled, harvested }
          : { ...field, disabled, harvested };
      });

    return selectedFields;
  };

  // update fields on map on crop change
  componentDidUpdate = prevProps => {
    const { activityform, updateMapFields, activityType } = this.props;
    if (!prevProps.activityform || !activityform) {
      return;
    }

    // do only when crop is updated
    if (
      prevProps.activityform.values &&
      activityform.values &&
      !isEqual(prevProps.activityform.values.crop, activityform.values.crop) &&
      activityType !== ACTIVITY_TYPES.SEEDING // don't update map for seeding activity
    ) {
      const fields = this.getSelectedFields(activityform);
      updateMapFields(fields);
    }
  };

  componentWillUnmount() {
    // reset the map zoom
    this.props.resetSelectedFields();
  }

  render() {
    const {
      id,
      activityform,
      activityType,
      changeValue,
      contracts,
      crops,
      fields,
      onCancel,
      showMapFlag,
      storages,
      initialValues,
      toggleFieldView,
      extra,
    } = this.props;

    const { page, openErrorModal } = this.state;

    let selectedFields;

    if (activityType !== ACTIVITY_TYPES.SEEDING) {
      selectedFields = this.getSelectedFields(activityform);
    }

    const _isMarkerDroppable = () =>
      page === 1 &&
      // Using [].includes() here just in case we have more activiy types
      // in the future that requrest the map pin drop feature
      // currently only support 'SCOUTING'
      ['SCOUTING'].includes(activityType);

    const _showFields = () =>
      page >= 1 &&
      ['SCOUTING', 'FERTILIZING', 'SPRAYING', 'HARVESTING', 'OTHER'].includes(
        activityType
      );

    const _showStorages = () =>
      page >= 1 && ['STORAGE', 'DELIVERY', 'OTHER'].includes(activityType);

    const _showStorageMarkers = () =>
      page >= 1 && ['STORAGE', 'DELIVERY'].includes(activityType);

    return (
      <FieldWrapper
        showStorages={_showStorages()}
        showStorageMarkers={_showStorageMarkers()}
        showFields={_showFields()}
        showMapFlag={showMapFlag}
        theme={[activityType && 'white']}
        mapOptions={{
          allowMarkerDrop: _isMarkerDroppable(),
          key: 'viewmode',
          markerDraggable: true,
          onLocationUpdate: location => this._setFieldLocaiton(location),
          pinIcon: activityType === 'SCOUTING' ? 'field' : 'storage',
          polygonClickable: false,
          usePreservedLocation: true,
          useMaxZoomService: true,
          withCurrentLocation: true,
          selectedField:
            // populate the field on map for scouting
            (activityType === ACTIVITY_TYPES.SCOUTING &&
              id !== 'add' &&
              initialValues &&
              fields.find(
                field => field.name === JSON.parse(initialValues.fieldName).name
              ).shape) ||
            [],
        }}
        nav={
          activityType && page === 1 ? (
            <LevelNav
              hideRightIcon
              nav={{
                left: {
                  label: <span className={'visible--desktop'}>Back</span>,
                  action: () => {
                    changeValue('crop', '');
                    history.goBack();
                  },
                },
                center: {
                  label: `${
                    id == 'add' ? 'Add' : 'Edit'
                  } ${activityType} Activity`,
                },
                right: {
                  label: showMapFlag ? 'Done' : null,
                  action: () => toggleFieldView(),
                },
              }}
            />
          ) : null
        }
      >
        {!activityType && (
          <LandingForm onSubmit={this.goToOption} onCancel={onCancel} />
        )}
        {activityType && (
          <div
            className="activity__form"
            style={{ display: page !== 1 && 'none' }}
          >
            <ActivityForm
              id={id}
              fields={selectedFields}
              goToOption={this.goToOption}
              onSelectedField={this.updateselectedField}
              onSubmit={this.onSubmit}
              onCancel={onCancel}
              selectedType={activityType}
              crops={crops}
              storages={storages}
              contracts={contracts}
              initialValues={initialValues}
              extra={extra}
            />
          </div>
        )}
        {activityType && page === 2 && (
          <this.state.component
            onSubmit={this.prevPage}
            fields={fields}
            crops={crops}
            activityType={activityType}
            storages={storages}
            contracts={contracts}
            populateAmount={this.populateAmount}
          />
        )}
        <ErrorModal
          open={openErrorModal}
          handleToggle={this._toggleErrorModal}
        />
      </FieldWrapper>
    );
  }
}

WizardForm.propTypes = {
  // from mapstate
  activityform: PropTypes.object,
  triggerBanner: PropTypes.func.isRequired,
  season: PropTypes.number.isRequired,
  showMapFlag: PropTypes.bool,

  // from graphQL
  fields: PropTypes.arrayOf(PropTypes.object),
  crops: PropTypes.arrayOf(PropTypes.object),
  originalCrop: PropTypes.object,
  storages: PropTypes.arrayOf(PropTypes.object),
  initialValues: PropTypes.object,
  contracts: PropTypes.arrayOf(PropTypes.object),
  onCreateFieldActivity: PropTypes.func,
  onUpdateFieldActivity: PropTypes.func,
  onUpdateStorageActivity: PropTypes.func,
  onUpdateDeliveryActivity: PropTypes.func,
  onCreateStorageActivity: PropTypes.func,
  onUpdateCrop: PropTypes.func,

  // manually added
  onCancel: PropTypes.func.isRequired,
  activityType: PropTypes.string,
  updateMapFields: PropTypes.func.isRequired,
  changeValue: PropTypes.func,
  id: PropTypes.string.isRequired,
  extra: PropTypes.string,
  resetSelectedFields: PropTypes.func.isRequired,
  toggleFieldView: PropTypes.func.isRequired,
};

const mapState = ({ form, settings, field }, { initialValues }) => ({
  activityform: form.activityform,
  season: settings.season,
  showMapFlag: field.showMapFlag,
  initialValues,
});

const mapDispatch = dispatch => ({
  onCancel: () => {
    dispatch(change('activityform', 'crop', ''));
    dispatch(push(ROUTE_ACTIVITY));
  },
  changeValue: (fieldname, value) =>
    dispatch(change('activityform', fieldname, value)),
  triggerBanner: (id, message, isError) =>
    dispatch(banner.display(id, message, isError)),
  updateMapFields: fields => ({ type: UPDATE_MAP_FIELDS, payload: fields }),
  toggleFieldView: () => dispatch({ type: FIELD_DISPLAY_TOGGLE }),
  resetSelectedFields: () => dispatch({ type: RESET_SELECTED_FIELD }),
});

const fetchFieldActivityGraphQLEnhancer = graphql(FETCH_ACTIVITY, {
  options: ({ id }) => ({
    variables: { id },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data, ownProps }) => {
    const { fields } = ownProps;
    if (!data || !data.getActivityForField) {
      return;
    }
    const activity = data.getActivityForField;
    return {
      initialValues: mapInitialValues(activity, { fields }),
      originalCrop: activity.crop,
    };
  },
});

const fetchStorageActivityGraphQLEnhancer = graphql(FETCH_STORAGE_ACTIVITY, {
  options: ({ id }) => ({
    variables: { id },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => {
    if (!data || !data.getActivityForStorage) {
      return;
    }
    const activity = data.getActivityForStorage;
    return {
      initialValues: mapInitialValuesForStorageActivity(activity),
    };
  },
});

const fetchDeliveryActivityGraphQLEnhancer = graphql(FETCH_DELIVERY_ACTIVITY, {
  options: ({ id }) => ({
    variables: { id },
    fetchPolicy: 'cache-and-network',
  }),
  props: ({ data }) => {
    if (!data || !data.getActivityForDelivery) {
      return;
    }
    const activity = data.getActivityForDelivery;
    return {
      initialValues: mapInitialValuesForDeliveryActivity(activity),
    };
  },
});

const fetchAllExceptActiviteisGraphQLEnhancer = graphql(
  FETCH_ALL_EXCEPT_ACTIVITIES,
  {
    options: () => ({
      variables: { season: store.getState().settings.season, active: true },
      fetchPolicy: 'cache-and-network',
    }),
    props: ({
      data: {
        getAllFields,
        getAllCropsForField,
        getAllStorages,
        getAllContracts,
      },
    }) => ({
      fields: getAllFields,
      crops: getAllCropsForField,
      storages: getAllStorages,
      contracts: getAllContracts,
    }),
  }
);

const createFieldActivityGraphQLEnhancer = graphql(
  MUTATION_CREATE_FIELD_ACTIVITY,
  {
    props: props => ({
      onCreateFieldActivity: fieldActivityCreateInput => {
        return props
          .mutate({
            variables: {
              fieldActivityCreateInput: omitDeep(
                fieldActivityCreateInput,
                '__typename'
              ),
            },
            optimisticResponse: {
              createActivityForField: buildActivitySchema(
                fieldActivityCreateInput,
                'FIELD'
              ),
            },
            update: proxy => {
              // Current version mockedProvider from react-apollo does not support mocked cache
              // TODO update react-apollo to mock cache and manually writeQuery in its corresponding test
              // and remove the following line
              if (process.env.NODE_ENV === 'test') return;
              // Read the data from our cache for this query.
              const proxyData = proxy.readQuery({
                query: FETCH_ALL_ACTIVITIES_WITH_FIELDS,
                variables: {
                  active: true,
                  season: fieldActivityCreateInput.season,
                },
              });
              const updatedData = buildActivitySchema(
                fieldActivityCreateInput,
                'FIELD'
              );
              proxyData.getAllActivitiesForField.push(updatedData);

              // Add our comment from the mutation to the end.
              // Write our data back to the cache.
              proxy.writeQuery({
                query: FETCH_ALL_ACTIVITIES_WITH_FIELDS,
                variables: {
                  active: true,
                  season: fieldActivityCreateInput.season,
                },
                data: proxyData,
              });
            },
          })
          .then(res => {
            return {
              ...res,
              createActivity: res.data && res.data.createActivityForField,
            };
          })
          .catch(graphQlToFormErrors);
      },
      ...props,
    }),
  }
);

const updateFieldActivityGraphQLEnhancer = graphql(
  MUTATION_UPDATE_FIELD_ACTIVITY,
  {
    props: props => ({
      onUpdateFieldActivity: (id, fieldActivityUpdateInput) => {
        return props
          .mutate({
            variables: {
              id,
              fieldActivityUpdateInput,
            },
          })
          .then(res => {
            return {
              ...res,
              updateActivity: res.data && res.data.updateActivityForField,
            };
          })
          .catch(graphQlToFormErrors);
      },
    }),
  }
);

const createStorageActivityGraphQLEnhancer = graphql(
  MUTATION_CREATE_STORAGE_ACTIVITY,
  {
    props: props => ({
      onCreateStorageActivity: storageActivityCreateInput => {
        const uuid = uuidv4();
        storageActivityCreateInput.uuid = uuid;
        return props
          .mutate({
            variables: {
              storageActivityCreateInput: omitDeep(
                storageActivityCreateInput,
                '__typename'
              ),
            },
            optimisticResponse: {
              createActivityForStorage: buildActivitySchema(
                storageActivityCreateInput,
                'STORAGE'
              ),
            },
            update: proxy => {
              // Read the data from our cache for this query.
              const proxyData = proxy.readQuery({
                query: FETCH_ALL_ACTIVITIES_WITH_FIELDS,
                variables: {
                  active: true,
                  season: storageActivityCreateInput.season,
                },
              });
              const updatedData = buildActivitySchema(
                storageActivityCreateInput,
                'STORAGE'
              );

              proxyData.getAllActivitiesForStorage.push(updatedData);

              // Add our comment from the mutation to the end.
              // Write our data back to the cache.
              proxy.writeQuery({
                query: FETCH_ALL_ACTIVITIES_WITH_FIELDS,
                variables: {
                  active: true,
                  season: storageActivityCreateInput.season,
                },
                data: proxyData,
              });
            },
          })
          .then(res => {
            return {
              ...res,
              createActivity: res.data && res.data.createActivityForStorage,
            };
          })
          .catch(graphQlToFormErrors);
      },
      ...props,
    }),
  }
);

const updateStorageActivityGraphQLEnhancer = graphql(
  MUTATION_UPDATE_STORAGE_ACTIVITY,
  {
    props: props => ({
      onUpdateStorageActivity: (id, storageActivityUpdateInput) => {
        return props
          .mutate({
            variables: {
              id,
              storageActivityUpdateInput,
            },
          })
          .then(res => {
            return {
              ...res,
              updateActivity: res.data && res.data.updateActivityForStorage,
            };
          })
          .catch(graphQlToFormErrors);
      },
    }),
  }
);

const createDeliveryActivityGraphQLEnhancer = graphql(
  MUTATION_CREATE_DELIVERY_ACTIVITY,
  {
    props: props => ({
      onCreateDeliveryActivity: deliveryActivityCreateInput => {
        const uuid = uuidv4();
        deliveryActivityCreateInput.uuid = uuid;
        return props
          .mutate({
            variables: {
              deliveryActivityCreateInput: omitDeep(
                deliveryActivityCreateInput,
                '__typename'
              ),
            },
            optimisticResponse: {
              createActivityForDelivery: buildActivitySchema(
                deliveryActivityCreateInput,
                'DELIVERY'
              ),
            },
            update: proxy => {
              // Read the data from our cache for this query.
              const proxyData = proxy.readQuery({
                query: FETCH_ALL_ACTIVITIES_WITH_FIELDS,
                variables: {
                  active: true,
                  season: deliveryActivityCreateInput.season,
                },
              });
              const updatedData = buildActivitySchema(
                deliveryActivityCreateInput,
                'DELIVERY'
              );

              proxyData.getAllActivitiesForDelivery.push(updatedData);

              // Add our comment from the mutation to the end.
              // Write our data back to the cache.
              proxy.writeQuery({
                query: FETCH_ALL_ACTIVITIES_WITH_FIELDS,
                variables: {
                  active: true,
                  season: deliveryActivityCreateInput.season,
                },
                data: proxyData,
              });
            },
          })
          .then(res => {
            return {
              ...res,
              createActivity: res.data && res.data.createActivityForDelivery,
            };
          })
          .catch(graphQlToFormErrors);
      },
      ...props,
    }),
  }
);

const createCropGraphQLEnhancer = graphql(MUTATION_CREATE_CROP, {
  options: () => ({
    onCompleted: ({ createCropForField }) => {
      if (createCropForField) {
        const { crop, plantedArea, season, expectedYield } = createCropForField;
        mixpanel.track(ANALYTICS.EVENTS.CROP.ADDED, {
          [ANALYTICS.PROPERTIES.CROP.NAME]: crop.name,
          [ANALYTICS.PROPERTIES.CROP.VARIETY]: crop.variety || '',
          [ANALYTICS.PROPERTIES.CROP.PLANTED_AREA]: plantedArea.size,
          [ANALYTICS.PROPERTIES.CROP.SEASON]: season,
          [ANALYTICS.PROPERTIES.CROP.EXPECTED_YIELD]:
            expectedYield[0].yield.size,
        });

        mixpanel.people.increment(ANALYTICS.PROPERTIES.ACCOUNT.CROPS_ADDED);
      }

      return createCropForField;
    },
  }),
  props: props => ({
    onCreateCrop: fieldCropCreateInput => {
      const { season, fieldName, crop } = fieldCropCreateInput;
      const expectedId = `CROPFIELD:${season}:${fieldName}:${
        crop.name
      }:${crop.variety || ''}`;

      const constructedCrop = {
        id: expectedId,
        expectedPrice: null,
        modifiedAt: null,
        createdAt: new Date().toISOString(),
        harvestDate: null,
        seedDate: null,
        ...fieldCropCreateInput,
        crop: {
          name: fieldCropCreateInput.crop.name,
          variety: fieldCropCreateInput.crop.variety || null,
        },
        expectedYield: [
          {
            timestamp: new Date().toISOString(),
            yield: fieldCropCreateInput.expectedYield,
          },
        ],
      };

      // stringify date object to avoid omitting
      const omittedInput = omitDeep(
        {
          ...fieldCropCreateInput,
          harvestDate: fieldCropCreateInput.harvestDate
            ? fieldCropCreateInput.harvestDate.toISOString()
            : null,
          seedDate: fieldCropCreateInput.seedDate
            ? fieldCropCreateInput.seedDate.toISOString()
            : null,
        },
        '__typename'
      );

      return props
        .mutate({
          variables: {
            fieldCropCreateInput: omittedInput,
          },
          optimisticResponse: () => ({
            createCropForField: buildCropchema(constructedCrop),
          }),
          // this is called twice when in online mode
          update: (cache, { data: { createCropForField } }) => {
            // Current version mockedProvider from react-apollo does not support mocked cache
            // TODO update react-apollo to mock cache and manually writeQuery in its corresponding test
            // and remove the following line
            if (process.env.NODE_ENV === 'test') return;
            const { season, fieldName } = fieldCropCreateInput;
            const cachedData = cache.readQuery({
              query: FETCH_FIELD_DETAILS_WITH_NAME,
              variables: {
                season,
                active: true,
                name: fieldName,
                id: generateFieldId(fieldName),
              },
            });

            const updatedCrop = buildCropchema(createCropForField);
            cachedData.getAllCropsForField = [
              ...cachedData.getAllCropsForField.filter(
                crop => crop.id !== createCropForField.id
              ),
              updatedCrop,
            ];

            const cachedObj = {
              query: FETCH_FIELD_DETAILS_WITH_NAME,
              variables: {
                season,
                active: true,
                name: fieldName,
                id: generateFieldId(fieldName),
              },
              data: cachedData,
            };
            cache.writeQuery(cachedObj);

            // update the crop to field list
            const fields = store.getState().map.fields;
            fields.map(field => {
              if (
                fieldName === field.name &&
                !field.crops.find(c => c.id === updatedCrop.id) // prevent same id added multiple times
              ) {
                field.crops.push(updatedCrop);
                return field;
              }
              return field;
            });
            store.dispatch({ type: UPDATE_MAP_FIELDS, payload: fields });
          },
        })
        .then(res => res)
        .catch(graphQlToFormErrors);
    },
    ...props,
  }),
});

const updateDeliveryActivityGraphQLEnhancer = graphql(
  MUTATION_UPDATE_DELIVERY_ACTIVITY,
  {
    props: props => ({
      onUpdateDeliveryActivity: (id, deliveryActivityUpdateInput) => {
        return props
          .mutate({
            variables: {
              id,
              deliveryActivityUpdateInput,
            },
          })
          .then(res => {
            return {
              ...res,
              updateActivity: res.data && res.data.updateActivityForDelivery,
            };
          })
          .catch(graphQlToFormErrors);
      },
    }),
  }
);

const deleteCropGraphQLEnhancer = graphql(MUTATION_DELETE_CROP, {
  options: () => ({
    onCompleted: ({ deleteCropForField }) => {
      if (deleteCropForField) {
        mixpanel.track(ANALYTICS.EVENTS.CROP.DELETED);
      }
    },
  }),
  props: props => ({
    onDeleteCrop: id => {
      return props.mutate({
        variables: { id },
      });
    },
  }),
});

const updateCropGraphQLEnhancer = graphql(MUTATION_UPDATE_CROP, {
  props: props => ({
    onUpdateCrop: (id, fieldCropUpdateInput) => {
      return props
        .mutate({
          variables: { id, fieldCropUpdateInput },
        })
        .then(res => res)
        .catch(graphQlToFormErrors);
    },
    ...props,
  }),
});

export default compose(
  fetchAllExceptActiviteisGraphQLEnhancer,
  fetchFieldActivityGraphQLEnhancer,
  fetchStorageActivityGraphQLEnhancer,
  fetchDeliveryActivityGraphQLEnhancer,

  createFieldActivityGraphQLEnhancer,
  updateFieldActivityGraphQLEnhancer,
  createStorageActivityGraphQLEnhancer,
  updateStorageActivityGraphQLEnhancer,
  createDeliveryActivityGraphQLEnhancer,
  updateDeliveryActivityGraphQLEnhancer,

  createCropGraphQLEnhancer,
  deleteCropGraphQLEnhancer,
  updateCropGraphQLEnhancer,

  connect(
    mapState,
    mapDispatch
  )
)(WizardForm);

export const WizardFormContainer = compose(
  connect(
    mapState,
    mapDispatch
  )
)(WizardForm);



// WEBPACK FOOTER //
// ./src/containers/ActivityForm/index.js